module.exports = {"511724001":"竹阳街道","511724002":"东柳街道","511724003":"白塔街道","511724101":"乌木镇","511724102":"团坝镇","511724103":"杨家镇","511724104":"清河镇","511724105":"柏林镇","511724106":"石河镇","511724107":"中华镇","511724108":"石桥铺镇","511724109":"观音镇","511724110":"周家镇","511724111":"石子镇","511724112":"文星镇","511724113":"妈妈镇","511724114":"高穴镇","511724115":"欧家镇","511724116":"庙坝镇","511724117":"清水镇","511724118":"月华镇","511724119":"高明镇","511724120":"童家镇","511724121":"天城镇","511724125":"四合镇","511724126":"永胜镇","511724203":"朝阳乡","511724214":"安吉乡","511724218":"八渡乡","511724220":"杨通乡","511724231":"川主乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511724.json
// module id = 2507
// module chunks = 0